import React from "react";
import SpeakerCard from "./components/speakercard";
import "./styles/index.css";

const speakersData = [
  {
    name: "Avni Srivastava",
    title: "Marketing Head",
    description:
      "Former Lead  DSC JECRC | Founder at Enhanceyaa ",
    linkedin: "https://www.linkedin.com/in/avni-srivastava/",
    image: "images/team/avni.jpg",
  },
  {
    name: "Avnish Singh",
    title: "Operations Head",
    description:
      "Former Lead, GDSC  BIAS | MLSA Alpha | Campaign Head @Women Unified",
    linkedin: "https://www.linkedin.com/in/singhavi279/",
    image: "images/team/Avnish.jpg",
  },
  {
    name: "Harsh Jain",
    title: "Marketing Head",
    description: "Former Lead, GDSC IIIT Bh | Community Intern, Progate",
    image: "images/team/harsh.jpeg",
    linkedin: "https://www.linkedin.com/in/harshjain2710/",
  },
  {
    name: "Poornachandra Kashi",
    title: "Sponsorship Head",
    image: "images/team/poorna.jpg",
    description: "Former Lead, GDSC TOCE | SDE Intern Mankutimma Studios",
    linkedin: "https://www.linkedin.com/in/poornachandrakashi/",
  },
  {
    title: "Management Head",
    linkedin: "https://www.linkedin.com/in/sanket-patil-b4134362/",
    name: "Sanket Patil",
    description:
      "Former Lead, GDSC JSCOE | Cloud Analyst at Bluepineapple ",
    image: "images/team/sanket.jpg",
  },
  {
    title: "Technical Head",
    linkedin: "https://www.linkedin.com/in/ksatyarth2/",
    name: "Kumar Satyarth",
    description:
      "Former Lead, GDSC ABESIT | Blockchain Developer, Timeswap",
    image: "images/team/satyarth.jpeg",
  },
  {
    name: "Sri Laasya Nutheti",
    title: "Design Head",
    description:
      "Former Lead, GDSC AUCE | Research Intern, MIT | GHC '21 Scholar",
    linkedin: "https://www.linkedin.com/in/sri-laasya/",
    image: "images/team/srilaasya.png",
  },
  {
    name: "Vanshika Garg",
    title: "Sponsorship Head",
    description:
      "Former Google DSC Lead & SDE Intern at CRIS | 21U21 Awardee | Fractal Analytics",
    image: "images/team/vanshika.jpg",
    linkedin: "https://www.linkedin.com/in/vanshikagarg17/",
  },
  {
    name: "Vanshita Singh",
    title: "Design Head",
    description:
      "Former Lead ABESEC | UI/UX Intern @1GEN",
    image: "images/team/Vanshita.jpg",
    linkedin: "https://www.linkedin.com/in/vanshita25/",
  },
  {
    name: "Viswanadha Vedvyas",
    title: "Management Head",
    description:
      "Former Lead, VIT - AP | Inquisitive | Coffee Aficionado",
    linkedin: "https://www.linkedin.com/in/vedvyas9/",
    image: "images/team/Viswanadha.jpg",
  },
  {
    name: "Yashank Jhamb",
    title: "Technical Head",
    description:
      "Former Lead, GDSC Chitkara University | SDE intern Rocketium",
    linkedin: "https://www.linkedin.com/in/yashank18/",
    image: "images/team/yashank.jpg",
  }
  
];

const Speakers = () => {
  return (
    <section className="speakers__wrapper" id="team-section">
      <div className="row section__header justify-content-center">
        <div className="col-md-10">Lead Organizers</div>
      </div>

      <div className="row justify-content-center">
        <div className="col-md-9 col-xs-12 ">
          <div className="row">
            {speakersData.map((e) => (
              <SpeakerCard
                key={e.linkedin}
                title={e.title}
                linkedin={e.linkedin}
                name={e.name}
                description={e.description}
                image={e.image}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Speakers;
